import React, { useCallback, useRef } from 'react';

import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
import { useClassifiedOfferDataLayerPush } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { useGtmOnVisible } from '@search/vtbeco-frontend-core/domain/google/useGtmOnVisible';

import { Typography } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';
import Image from '@search/vtbeco-frontend-core/view/common/components/Image';

import classname from '@search/classname/src';
import vtbLogo from '../preview/vtbLogo.url.svg';
import IllustrationDesktop from '../preview/IllustrationDesktop.url.png';

import './styles.css';

export const cn = classname.bind(null, 'PitBannerDesktop');

export const PitBannerDesktop = ({
    showPhoneNumber,
    phoneRef,
    phoneFormatted
}: {
    phoneRef: string | undefined;
    phoneFormatted: string | undefined;
    showPhoneNumber: () => void;
}) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const staticPath = useStaticPathConfig();
    const dataLayerPush = useClassifiedOfferDataLayerPush();

    const onVisible = useCallback(() => {
        dataLayerPush({ event: 'classified_im_trade_banner_view' });
    }, [ dataLayerPush ]);

    useGtmOnVisible({ containerRef, onVisible });
    return (
        <div className={cn()} ref={containerRef}>
            <div className={cn('description')}>
                <Typography variant='h2' bold>
                    Этот объект продается с&nbsp;торгов
                </Typography>
                <ul className={cn('list')}>
                    <li className={cn('list-item')}><Icon name='check-circle' size='m' /> Выгодные условия
                        покупки
                    </li>
                    <li className={cn('list-item')}><Icon name='check-circle' size='m' /> Сопровождение
                        участия в&nbsp;торгах&nbsp;под&nbsp;ключ
                    </li>
                    <li className={cn('list-item')}><Icon name='check-circle' size='m' /> Проведение
                        безопасной сделки&nbsp;купли&#8209;продажи
                    </li>
                </ul>
                <div className={cn('contact')}>
                    Обсудите подробности по&nbsp;телефону
                    <span
                        className={cn('phone')}
                        onClick={showPhoneNumber}
                    >
                        {phoneRef && phoneFormatted ? (
                            <a href={phoneRef}>{phoneFormatted}</a>
                        ) : 'Показать телефон'}
                    </span>
                </div>
            </div>
            <div className={cn('img')}>
                <Image
                    url={`${staticPath}${IllustrationDesktop}`}
                    width={329}
                    height={199}
                    className={cn('img-illustration')}
                />
                <Image url={`${staticPath}${vtbLogo}`} className={cn('img-logo')} />
            </div>
        </div>
    );
};
